import virtus from './virtus.vue';

const virtusRoutes = [
  {
    path: '/virtus',
    component: virtus,
    children: [
      {
        path: '',
        redirect: { name: 'virtusSearch' },
      },
      {
        path: 'search',
        name: 'virtusSearch',
        component: () => import('./search/virtusSearch.vue'),
        meta: {
          requiresAuth: true,
          title: 'Virtus Golf · Find a Tee Time',
        },
      },
      {
        path: 'request/new/:clubId',
        name: 'virtusRequestForm',
        component: () => import('./request/requestForm.vue'),
        meta: {
          requiresAuth: true,
          title: 'Virtus Golf · Request a Tee Time',
        },
        props: true,
      },
      {
        path: 'request/review',
        name: 'virtusRequestReview',
        component: () => import('./request/requestReview.vue'),
        meta: {
          requiresAuth: true,
          title: 'Virtus Golf · Review Request',
        },
      },
      {
        path: 'request/submitted/:id',
        name: 'virtusRequestSubmitted',
        component: () => import('./request/requestSubmitted.vue'),
        meta: {
          requiresAuth: true,
          title: 'Virtus Golf · Request Submitted',
        },
        props: true,
      },
      {
        path: 'my-requests',
        name: 'virtusMyRequests',
        component: () => import('./request/myRequests.vue'),
        meta: {
          requiresAuth: true,
          title: 'Virtus Golf · My Requests',
        },
      },
      {
        path: 'my-requests/:id',
        name: 'virtusRequestDetail',
        component: () => import('./request/requestDetail.vue'),
        meta: {
          requiresAuth: true,
          title: 'Virtus Golf · Request Detail',
        },
        props: true,
      },
    ],
  },
];

export default virtusRoutes;
